import { render, staticRenderFns } from "./DropOff.vue?vue&type=template&id=bbc770e4&scoped=true"
import script from "./DropOff.vue?vue&type=script&lang=js"
export * from "./DropOff.vue?vue&type=script&lang=js"
import style0 from "./DropOff.vue?vue&type=style&index=0&id=bbc770e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbc770e4",
  null
  
)

export default component.exports